import { render } from "./CriacaoEdicaoLayoutModal.vue?vue&type=template&id=8107f99e&scoped=true&ts=true"
import script from "./CriacaoEdicaoLayoutModal.vue?vue&type=script&lang=ts"
export * from "./CriacaoEdicaoLayoutModal.vue?vue&type=script&lang=ts"

import "./CriacaoEdicaoLayoutModal.vue?vue&type=style&index=0&id=8107f99e&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8107f99e"]])

export default __exports__